import KanBoIcon from 'components/KanBoIcon'
import React, { useMemo } from 'react'
import {
  Breadcrumb
} from 'react-bootstrap'
import styled from 'styled-components'

const StyledBreadcrumb = styled(Breadcrumb)`
  display: inline;
  padding: 0;
  margin: 0;
  background-color: transparent;
`

const HomeIcon = styled(KanBoIcon)`
  font-size: 18px;
  padding: 0 2px;
`

const PathIcon = styled(KanBoIcon)`
  font-size: 16px;
  margin-right: 5px;
`

type Props = {
  path?: any[]
  onIndexClick?: (index: number) => void
}

const PathBreadcrumb: React.FC<Props> = ({
  path = [],
  onIndexClick,
}) => {
  const visiblePath = useMemo(() => path.filter(path => !path.hidden), [path])

  const pathLength = visiblePath.length

  return (
    <StyledBreadcrumb>
      <Breadcrumb.Item
        active={pathLength === 0}
        onClick={onIndexClick ? () => onIndexClick(-1) : undefined}
      >
        <HomeIcon
          name='kanbo-24-home'
        />
      </Breadcrumb.Item>
      {visiblePath.map((pathItem, index) => {
        const isActive = index === pathLength - 1

        let icon
        if (!pathItem.url) {
          if (pathItem.documentSourceId) {
            icon = <PathIcon name='kanbo-16-document-sources' />
          } else if (pathItem.documentTemplateSourceId) {
            icon = <PathIcon name='kanbo-16-document-template-source' />
          }
        }

        return (
          <Breadcrumb.Item
            key={`${index}-${pathItem.path}`}
            active={isActive}
            onClick={(!isActive && onIndexClick) ? () => onIndexClick(index) : undefined}
          >
            {icon}
            {pathItem.name}
          </Breadcrumb.Item>
        )
      })}
    </StyledBreadcrumb>
  )
}

export default PathBreadcrumb
